import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte, BokkzAlgDataService, IncomeTaxEntity,
    JaarrekeningInvesteringen,
    Onderneming
} from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-investeringen',
    templateUrl: './investeringen.component.html',
    styleUrls: ['./investeringen.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiDetailsModule,
        SharedUiDialogModule,
        SharedUiButtonModule,
        CommonModule,
        SharedUiAlertModule
    ]
})
export class InvesteringenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);

    private focusedElementId: string | null = null;
    public dialogVisible = false;

    public ondernemingFG: FormGroup;
    public formStructure: any;
    public ondernemingLength: any;

    public heeftSamenwerkingsverband = {} as boolean;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nee' }
    ];

    public miaLetter: SelectFormControlItem<string>[] = [
        { value: 'A', label: 'A = 36% MIA + 75% Vamil' },
        { value: 'B', label: 'B = 27% MIA + 75% Vamil' },
        { value: 'C', label: 'C = alleen 75% Vamil' },
        { value: 'D', label: 'D = alleen 36% MIA' },
        { value: 'E', label: 'E = alleen 27% MIA' },
        { value: 'F', label: 'F = 45% MIA + 75% Vamil' },
        { value: 'G', label: 'G = alleen 45% MIA' }];

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public index = 0;

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.ondernemingFG = this.fb.group({
            ondernemingen: this.fb.array([])
        });
    }

    //onderneming
    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    createOndernemingFormGroup(onderneming?: Onderneming) {
        return this.dataService.createOndernemingFormGroup(onderneming);
    }

    //investeringen
    getInvesteringen(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('investeringen') as FormArray;
    }

    addInvesteringen(index: number): void {
        const innerGroup = this.fb.group<JaarrekeningInvesteringen>({
            omschrijving: '',
            datumIngebruikname: undefined,
            aandeelInInvesteringsBedrag: undefined,
            claimEIA: undefined,
            investeringsbedragEIA: undefined,
            meldingsNummerEia: undefined,
            claimMIA: undefined,
            investeringsbedragMIA: undefined,
            meldingsNummerMia: undefined,
            miaLetter: undefined,
            claimKIA: undefined,
            investeringsbedragKIA: undefined,
            reedsBetaaldDoorAangever: undefined,
            grondslagDesinvestering: undefined,
            percentageInvesteringsaftrek: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('investeringen') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteInvesteringen(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getInvesteringen(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    //desinvesteringen
    addDesInvesteringen(index: number): void {
        const innerGroup = this.fb.group<JaarrekeningInvesteringen>({
            omschrijving: '',
            grondslagDesinvestering: undefined,
            percentageInvesteringsaftrek: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('investeringen') as FormArray;
        innerArray.push(innerGroup);
    }

    createInvesteringenFormGroup(investering?: JaarrekeningInvesteringen) {
        return this.fb.group(({
            omschrijving: investering?.omschrijving || '',
            datumIngebruikname: investering ? investering.datumIngebruikname : undefined,
            aandeelInInvesteringsBedrag: investering ? investering.aandeelInInvesteringsBedrag : undefined,
            claimEIA: investering ? investering.claimEIA : undefined,
            investeringsbedragEIA: investering ? investering.investeringsbedragEIA : undefined,
            meldingsNummerEia: investering ? investering.meldingsNummerEia : undefined,
            claimMIA: investering ? investering.claimMIA : undefined,
            investeringsbedragMIA: investering ? investering.investeringsbedragMIA : undefined,
            meldingsNummerMia: investering ? investering.meldingsNummerMia : undefined,
            miaLetter: investering ? investering.miaLetter : undefined,
            claimKIA: investering ? investering.claimKIA : undefined,
            investeringsbedragKIA: investering ? investering.investeringsbedragKIA : undefined,
            reedsBetaaldDoorAangever: investering ? investering.reedsBetaaldDoorAangever : undefined,
            grondslagDesinvestering: investering ? investering.grondslagDesinvestering : undefined,
            percentageInvesteringsaftrek: investering ? investering.percentageInvesteringsaftrek : undefined
        } as JaarrekeningInvesteringen));
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner;
                    this.updateForm();
                });
                this.ondernemingFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.ondernemingen.valueChanges.subscribe(value => {
                    this.ondernemingLength = value;
                });
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter(
                    (event: Event): event is NavigationEnd =>
                        event instanceof NavigationEnd
                )
            )
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
        this.dataService.heeftSamenwerkingsverbandWuo.subscribe((heeftSamenwerkingsverband) => {
            this.heeftSamenwerkingsverband = heeftSamenwerkingsverband;
        });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.ondernemingFG.dirty;
    }

    private updateForm(): void {
        let ondernemingenLijst = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                ondernemingenLijst = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
            }
        });
        const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > ondernemingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update ondernemingen
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(ondernemingenLijst[i]);
            } else {
                const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i]);
                formArray.push(formGroup);
            }
        }
        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        // Update investeringen array elke onderneming
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const investeringen = onderneming.investeringen || [];
            const investeringenFormArray = this.getInvesteringen(i);
            while (investeringenFormArray.length > investeringen.length) {
                investeringenFormArray.removeAt(investeringenFormArray.length - 1);
            }
            for (let c = 0; c < investeringen.length; c++) {
                if (c < investeringenFormArray.length) {
                    const control = investeringenFormArray.at(c) as FormGroup;
                    control.patchValue(investeringen[c]);
                } else {
                    const inv = this.createInvesteringenFormGroup(investeringen[c]);
                    investeringenFormArray.push(inv);
                }
            }
        }
    }

    saveForm(): void {
        setTimeout(() => {
            if (!this.partnerBoolean) {
                this.incomeTaxEntity.aangifte = {
                    ...this.incomeTaxEntity.aangifte,
                    box1: {
                        ...this.incomeTaxEntity.aangifte?.box1,
                        winstUitOnderneming: {
                            ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                            ondernemingen: this.ondernemingFG.value.ondernemingen
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            } else {
                this.incomeTaxEntity.aangifte = {
                    ...this.incomeTaxEntity.aangifte,
                    partnerAangifte: {
                        ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                        box1: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
                            winstUitOnderneming: {
                                ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                                ondernemingen: this.ondernemingFG.value.ondernemingen
                            }
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            }
        }, 0);
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.box1 &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }

}


